import { setPinWidgetsFlyout, isPinWidgetsFlyout } from "../../externalApi/WindowApi";
// Expose window pin APIs
export class WidgetWindowPin {
    async setPinWidgetsFlyout(isPinWidgetsFlyout) {
        return await setPinWidgetsFlyout(isPinWidgetsFlyout);
    }
    async isPinWidgetsFlyout() {
        return await isPinWidgetsFlyout();
    }
}
